<template>
  <div class="invoice-page-center">
    <div class="accounts-table-container" style="margin-bottom: 24px;">
      <!-- User Balance -->
      <div style="margin-bottom: 20px;">
        <span style="font-size: 1.5rem; font-weight: bold; color: #2d3748;">
          Saldo: {{ formatCurrency(balance) }}
        </span>
      </div>
      <!-- Button: Ajukan Penarikan Dana -->
      <div v-if="!showForm" style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
        <button
          @click="showForm = true"
          style="background-color: #007bff; color: #fff; border: none; border-radius: 4px; padding: 8px 20px; font-weight: bold; cursor: pointer; box-shadow: 0 2px 6px rgba(0,123,255,0.08); transition: background 0.2s;"
        >
          + Ajukan Penarikan Dana
        </button>
      </div>
      <!-- Form: Ajukan Penarikan Dana -->
      <form v-if="showForm" @submit.prevent="submitWithdrawal" style="margin-bottom: 20px;">
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div style="flex: 1 1 220px; min-width: 220px;">
            <label style="font-weight: 500; margin-bottom: 4px; display: block;">Bank</label>
            <select v-model="form.bank_account" required style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ced4da;">
              <option disabled value="">Pilih Bank</option>
              <option v-for="bank in bankAccounts" :key="bank.id" :value="bank.id">
                {{ bankDisplay(bank) }}
              </option>
            </select>
          </div>
          <div style="flex: 1 1 180px; min-width: 180px;">
            <label style="font-weight: 500; margin-bottom: 4px; display: block;">Jumlah</label>
            <input v-model.number="form.amount" type="number" min="10000" required placeholder="Jumlah penarikan" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ced4da;" />
          </div>
        </div>
        <div style="margin-top: 12px;">
          <label style="font-weight: 500; margin-bottom: 4px; display: block;">Catatan (Opsional)</label>
          <textarea v-model="form.notes" rows="2" placeholder="Catatan tambahan" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ced4da;"></textarea>
        </div>
        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px;">
          <button type="button" @click="cancelForm" style="background: #f8f9fa; color: #333; border: 1px solid #dee2e6; border-radius: 4px; padding: 8px 16px; font-weight: 500; cursor: pointer;">
            Batal
          </button>
          <button type="submit" style="background-color: #007bff; color: #fff; border: none; border-radius: 4px; padding: 8px 20px; font-weight: bold; cursor: pointer;">
            Kirim Permohonan
          </button>
        </div>
      </form>
      <!-- Table: Withdrawal Requests -->
      <div style="overflow-x: auto;">
        <table class="accounts-table">
          <thead>
            <tr>
              <th>Tanggal Diajukan</th>
              <th>Jumlah</th>
              <th>Status</th>
              <th>Bank</th>
              <th>Nomor Rekening</th>
              <th>Tanggal Diproses</th>
              <th>Tanggal Selesai</th>
              <th>Catatan</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in withdrawalRequests" :key="item.id">
              <td>{{ formatDate(item.tanggal_diajukan) }}</td>
              <td>{{ formatCurrency(item.amount) }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.bank_name || item.bank }}</td>
              <td>{{ item.account_number || item.nomor_rekening }}</td>
              <td>{{ formatDate(item.tanggal_diproses) }}</td>
              <td>{{ formatDate(item.tanggal_selesai) }}</td>
              <td>{{ item.notes || item.catatan }}</td>
            </tr>
            <tr v-if="withdrawalRequests.length === 0">
              <td colspan="8" class="no-accounts">Tidak ada data penarikan.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invoice-page-center {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 60vh;
  background: #f7fafc;
  padding: 2.5rem 0 2rem 0;
}

.accounts-table-container {
  margin: 2.5rem auto 0 auto;
  width: 100%;
  max-width: 1100px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  padding: 2rem 2.5rem;
}

.accounts-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  margin-top: 1.5rem;
  font-size: 1rem;
}

.accounts-table thead th {
  background: #f7fafc;
  color: #2d3748;
  font-weight: 600;
  padding: 1rem 0.75rem;
  border-bottom: 2px solid #e2e8f0;
  text-align: left;
}

.accounts-table tbody td {
  padding: 0.9rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
  vertical-align: middle;
}

.accounts-table tbody tr:last-child td {
  border-bottom: none;
}

.accounts-table tbody tr:hover {
  background: #f1f5f9;
  transition: background 0.2s;
}

.no-accounts {
  text-align: center;
  color: #a0aec0;
  font-style: italic;
  padding: 1.5rem 0;
}
</style>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'MyInvoices',
  data() {
    return {
      withdrawalRequests: [],
      showForm: false,
      form: {
        bank_account: '',
        amount: '',
        notes: ''
      },
      bankAccounts: [],
      balance: 0
    }
  },
  methods: {
    async fetchWithdrawalRequests() {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/withdrawal-requests/`, {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        });
        if (!response.ok) throw new Error('Gagal memuat data');
        const data = await response.json();
        this.withdrawalRequests = Array.isArray(data) ? data : (data.results || []);
      } catch (e) {
        this.withdrawalRequests = [];
      }
    },
    async fetchBankAccounts() {
      // Try to fetch user's bank accounts, fallback to static if not available
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/bank-accounts/`, {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        });
        if (!response.ok) throw new Error('Gagal memuat rekening bank');
        const data = await response.json();
        this.bankAccounts = Array.isArray(data) ? data : (data.results || []);
      } catch (e) {
        this.bankAccounts = [];
      }
    },
    async fetchBalance() {
      try {
        const token = localStorage.getItem('token');
        // If backend needs user id in path, get from localStorage
        let userId = localStorage.getItem('username') || localStorage.getItem('id');
        let balanceUrl = `${process.env.VUE_APP_API_BASE_URL}/api/users/me/balance/`;
        // If backend expects /api/users/{userid}/balance/ instead of /me/
        if (userId && process.env.VUE_APP_USE_USERID_BALANCE === 'true') {
          balanceUrl = `${process.env.VUE_APP_API_BASE_URL}/api/users/${userId}/balance/`;
        }
        const response = await fetch(balanceUrl, {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        });
        if (!response.ok) throw new Error('Gagal memuat saldo');
        const data = await response.json();
        this.balance = data.balance || 0;
      } catch (e) {
        this.balance = 0;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (isNaN(d)) return '-';
      return d.toLocaleDateString('id-ID');
    },
    formatCurrency(amount) {
      if (typeof amount !== 'number') amount = Number(amount);
      if (isNaN(amount)) return '-';
      return amount.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' });
    },
    bankDisplay(bank) {
      return `${bank.bank_name.toUpperCase()} - ${bank.account_name} (${bank.account_number})`;
    },
    cancelForm() {
      this.showForm = false;
      this.form = { bank_account: '', amount: '', notes: '' };
    },
    async submitWithdrawal() {
      try {
        const payload = {
          bank_account: this.form.bank_account,
          amount: this.form.amount,
          notes: this.form.notes
        };
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/withdrawal-requests/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.detail || 'Gagal mengajukan penarikan');
        }
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Permohonan penarikan berhasil diajukan!',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
        this.cancelForm();
        await this.fetchWithdrawalRequests();
        await this.fetchBalance();
      } catch (e) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: e.message || 'Gagal mengajukan penarikan',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true
        });
      }
    }
  },
  mounted() {
    this.fetchWithdrawalRequests();
    this.fetchBankAccounts();
    this.fetchBalance();
  }
}
</script>